import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { gql } from "@apollo/client";
import Button, { ButtonVariant } from "./Button";
import ExpandableArea from "./ExpandableArea";
import SyntaxHighlighter from "react-syntax-highlighter";
import CopyToClipboard from "react-copy-to-clipboard";
import Helmet from "react-helmet";
import { currentShopifyVersionVar } from "../helpers/client";
gql `
fragment EmbedCodeInstructions on Business {
  id
  alias
  name
  features {
    name
    completed
  }
}
`;
const embedCodeFor = (alias) => {
    return `<a href="${process.env.REACT_APP_WITHFRIENDS_HOST}/${alias}/join?utm_campaign=wf-websitelink">
    <img src="${process.env.REACT_APP_ASSET_HOST}/api/embed-btn.svg" width="225"/>
</a>
<script type="text/javascript" src="${process.env.REACT_APP_ASSET_HOST}/api/wf-embed-btn.js?b=${alias}"></script>`;
};
const EmbedCodeInstructions = ({ props }) => {
    var _a, _b;
    const embedHost = process.env.REACT_APP_WITHFRIENDS_HOST.split("/").pop();
    const embedLink = `${process.env.REACT_APP_WITHFRIENDS_HOST}/${props.alias}/join?utm_campaign=wf-websitelink`;
    const embedScript = `${process.env.REACT_APP_ASSET_HOST}/api/wf-embed-btn.js?b=${props.alias}&host=${embedHost}`;
    const currentShopifyVersion = currentShopifyVersionVar();
    return (_jsx(ExpandableArea, { expandedStart: false, title: `Use our embed code on your website`, done: (_b = (_a = props === null || props === void 0 ? void 0 : props.features) === null || _a === void 0 ? void 0 : _a.find((f) => f.name === "Website")) === null || _b === void 0 ? void 0 : _b.completed, children: _jsxs("article", { className: "prose max-w-none mt-4 pt-4 border-t-2 mb-2", children: [_jsxs("p", { children: [currentShopifyVersion == 2
                            ? "If you have a website in addition to your Shopify store, you can use "
                            : "Use ", "our embed code to allow your visitors to buy memberships without leaving your website!"] }), _jsx("a", { href: embedLink, target: "blank", children: _jsx("img", { src: `${process.env.REACT_APP_ASSET_HOST}/api/embed-btn.svg`, style: {
                            width: "225px",
                            marginTop: "1rem",
                            marginBottom: "1rem",
                        } }) }), _jsx(Helmet, { children: _jsx("script", { src: embedScript }) }), _jsx(CopyToClipboard, { text: embedCodeFor(props.alias), children: _jsx(Button, { className: "my-4", variant: ButtonVariant.Outlined, children: "Copy script to clipboard" }) }), _jsx(SyntaxHighlighter, { language: "xml", children: embedCodeFor(props.alias) }), _jsxs("ul", { className: "list-none", children: [_jsxs("li", { children: ["To use your own button design, replace the", " ", _jsx("strong", { children: "<img/>" }), " tag above with your design."] }), _jsxs("li", { children: ["Want a refresher on how to use embed codes? Check out", " ", _jsx("a", { href: "https://help.withfriends.co/3666258-add-the-withfriends-button-to-my-website", target: "_blank", rel: "noopener noreferrer", children: "our guide here" }), ". If you use Wix, you may need this."] })] })] }) }, props.name));
};
export default EmbedCodeInstructions;
